<div class="host-draggable-operator">
  <div class="left" (click)="onClickScroll.emit('L')">
    <i nz-icon nzType="left" nzTheme="outline"></i>
  </div>
  <div class="center">
    <div class="operators h-[46px] flex flex-row items-center">
      <div class="operator">
        <img
          [src]="'/assets/v4/icon-calendar-view.png'"
          alt
          nz-dropdown
          nzTrigger="click"
          [nzDropdownMenu]="viewMenu" />
      </div>

      @if (widgetType === "status") {
        <div class="operator" (click)="onClickDeposit.emit()">
          <img [src]="'/assets/calendar/operator_deposit.svg'" alt />
        </div>
        <div class="operator" (click)="onClickWidget.emit('today')">
          <div class="marker dot" *ngIf="widgetCount?.today_task_count"></div>
          <img
            hostI18nImageSwitcher
            [urls]="['/assets/calendar/operator_today.png', '/assets/calendar/operator_today_en.png']" />
        </div>
        <div class="operator" (click)="onClickWidget.emit('tomorrow')">
          <div class="marker dot" *ngIf="widgetCount?.tomorrow_task_count"></div>
          <img
            hostI18nImageSwitcher
            [urls]="['/assets/calendar/operator_tomorrow.png', '/assets/calendar/operator_tomorrow_en.png']"
            alt />
        </div>
        <div class="operator" (click)="onClickWidget.emit('box')">
          <div class="marker animate" *ngIf="widgetCount?.box_count">
            {{ widgetCount?.box_count }}
          </div>
          <img src="/assets/calendar/operator-order.png" alt />
        </div>
        <div class="operator" acl="master" nz-dropdown nzTrigger="click" [nzDropdownMenu]="shareMenu">
          <img src="/assets/calendar/operator-share.svg" alt />
        </div>
        <span class="line"></span>
      }

      <div class="operator" (click)="onClickScroll.emit()">
        <button nz-button class="rounded-[16px] no-min-width">
          {{ "word.today" | translate }}
          <!-- 今天 -->
        </button>
      </div>

      @if (widgetType === "price") {
        <div class="operator">
          <button
            nz-button
            nzType="primary"
            class="rounded-[16px]"
            nz-dropdown
            nzTrigger="click"
            [nzDropdownMenu]="editMenu">
            {{ "price-operate_bar_html_批量修改" | translate }}
          </button>
        </div>
      }
    </div>
  </div>
  <div class="right" (click)="onClickScroll.emit('R')">
    <i nz-icon nzType="right" nzTheme="outline"></i>
  </div>
</div>

<nz-dropdown-menu #editMenu="nzDropdownMenu">
  <ul nz-menu>
    <a class="text-[#000000d9]" routerLink="/app/price/bulk-price-editing">
      <li nz-menu-item>
        {{ "price-operate_bar_html_批量改价" | translate }}
      </li>
    </a>
    <a class="text-[#000000d9]" routerLink="/app/price/bulk-restrictions-editing">
      <li nz-menu-item>
        {{ "price-operate_bar_html_批量改规则" | translate }}
      </li>
    </a>
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #viewMenu="nzDropdownMenu">
  <ul nz-menu>
    @switch (widgetType) {
      @case ("price") {
        <li nz-menu-item (click)="onToggleDisplayStock.emit(!displayStock)">
          <v4-selectable-menu-item [checked]="!displayStock">{{
            "calendar.filter.hide_stock" | translate
          }}</v4-selectable-menu-item>
        </li>

        <li nz-menu-item (click)="onToggleDisplayThousandsSep.emit(!displayThousandsSep)">
          <v4-selectable-menu-item [checked]="!displayThousandsSep">{{
            "calendar.filter.hide_thousands_sep" | translate
          }}</v4-selectable-menu-item>
        </li>
      }
      @case ("status") {
        <li nz-menu-item (click)="onToggleDisplayLeadPrice.emit(!displayLeadPrice)">
          <v4-selectable-menu-item [checked]="displayLeadPrice">
            {{ "single_house_status_calendar_html_opt_view_show_price" | translate }}
            <!-- Show price of the lead channel -->
          </v4-selectable-menu-item>
        </li>
        <li nz-menu-item (click)="onToggleDisplayLeadRules.emit(!displayLeadRules)">
          <v4-selectable-menu-item [checked]="displayLeadRules">
            {{ "single_house_status_calendar_html_opt_view_show_rules" | translate }}
            <!-- Show booking rules of the lead channel -->
          </v4-selectable-menu-item>
        </li>
      }
    }
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #shareMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="onClickShare.emit('entire')">
      {{ "status-calendar-operate_bar_html_share_entire" | translate }}
    </li>

    <li nz-menu-item (click)="onClickShare.emit('partial')">
      {{ "status-calendar-operate_bar_html_share_specific" | translate }}
    </li>

    <li nz-menu-item (click)="onClickShare.emit('link')">
      {{ "status-calendar-operate_bar_html_share_manage" | translate }}
    </li>
  </ul>
</nz-dropdown-menu>
